import { render, staticRenderFns } from "./CompareCoordinatesModal.vue?vue&type=template&id=2dff156c&"
import script from "./CompareCoordinatesModal.vue?vue&type=script&lang=ts&"
export * from "./CompareCoordinatesModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports